import * as React from 'react';

import PageComponent from 'D:/Code/fpx-giws-web/src/pages/Billboard';

const PageComponentName = PageComponent;

export default PageComponentName;
